<template>
    <div class="rzy-page">
		<el-card style="margin-bottom: 15px;">
			<div class="rzy-top-bar">
			    <div style="margin-left: 0%; display: flex; flex-direction: row; ">
			        <div style="width: 20%;line-height: 40px;">出货日期</div>
			        <el-date-picker style="" @change="daterangeSelectChange()" v-model="daterangeSelectResult"
			            type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
			            end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd">
			        </el-date-picker>
			    </div>
			    <div style="margin-left: 3%; display: flex; flex-direction: row; ">
			        <div style="width: 30%;line-height: 40px;">查询条件</div>
			        <el-select v-model="optionsvalue" placeholder="请选择">
			            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
			            </el-option>
			        </el-select>
			    </div>
			    <el-button style="margin-left: 1%;" type="primary" icon="el-icon-search" @click="enquery()">查询</el-button>
			    <el-button type="primary" @click="Print" icon="el-icon-printer">打印</el-button>
			</div>
		</el-card>

        <div v-if="isclient" id="localListTableId_client">
            <el-table :data="responseData" :header-cell-style="{'text-align':'center'}" :cell-style="{'padding':'0px'}"
                border stripe show-summary :summary-method="getSummaries" v-loading="loading">

                <el-table-column sortable type="index" label="行" align="center">
                </el-table-column>
                <el-table-column prop="customer" label="客户名称" align="center">
                </el-table-column>
                <el-table-column prop="productWeight" label="出货重量(千克)" align="center">

                </el-table-column>
                <el-table-column prop="productLength" label="出货米数(米)" align="center">
                </el-table-column>

                <el-table-column prop="juanbuCount" label="出货匹数" align="center">
                </el-table-column>

                <el-table-column prop="opration" label="操作" align="center">
                    <template slot-scope="scope">
                        <el-link type="primary" @click="gotoShipmentDetails(scope.row.customer)">{{scope.row.opration}}</el-link>
                    </template>
                </el-table-column>
            </el-table>
        </div>
		
		<div v-if="ismaterial" id="localListTableId_material">
		    <el-table :data="responseData" :header-cell-style="{'text-align':'center'}" :cell-style="{'padding':'0px'}"
		        border stripe show-summary :summary-method="getSummaries" v-loading="loading">
		
		        <el-table-column sortable type="index" label="行" align="center">
		        </el-table-column>
		        <el-table-column prop="materialName" label="物料名称" align="center">
		        </el-table-column>
		        <el-table-column prop="materialNumber" label="物料编号" align="center">
		        </el-table-column> 
		        <el-table-column prop="productWeight" label="出货重量(千克)" align="center">
		
		        </el-table-column>
		        <el-table-column prop="productLength" label="出货米数(米)" align="center">
		        </el-table-column>
		
		        <el-table-column prop="juanbuCount" label="出货匹数" align="center">
		        </el-table-column>
		
		        <el-table-column prop="opration" label="操作" align="center">
		            <template slot-scope="scope">
		                <el-link type="primary" @click="gotoShipmentDetails(scope.row.materialName,scope.row.materialId)">{{scope.row.opration}}</el-link>
		            </template>
		        </el-table-column>
		    </el-table>
		</div>
    </div>
</template>

<script>
    import printJS from 'print-js'
    export default {
        data() {
            return {
				loading:false,
                //分页 -- sta
                pageInfo: {
                    page: 1,
                    size: 999,

                },
                responseData: [
                    // 调试用假数据--正式版注释掉
                    // {
                    //     shipmentTime: '2023-01-31',
                    //     client: 'K1',
                    //     operator: 'XXX',
                    //     materialName: 'W1',
                    //     materialNumber: '123456',
                    //     shipmentWeight: '1000',
                    //     shipmentMeter: '100',
                    //     shipmentNumber: '10',
                    //     opration: '详情',
                    // },
					
                ],
                
                //日期范围选择控件 -- sta
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);

                        }
                    }]
                },
                daterangeSelectResult: [], //日期范围 选择的结果
                //日期范围选择控件 -- end
                options: [{
                    value: 0,
                    label: '按物料'
                }, {
                    value: 1,
                    label: '按客户'
                }],
                optionsvalue: '',
				optionlabel: ['material', 'customer'],
				isclient: false,
				ismaterial: false,
            }
        },
		created() {
			this.getList(1)
		},
        mounted() {
            // this.getList(1)
			this.optionsvalue = sessionStorage.getItem("optionsvalue")?Number(sessionStorage.getItem("optionsvalue")):''
			let daterangeSelectResult0 = sessionStorage.getItem("daterangeSelectResult0")?sessionStorage.getItem("daterangeSelectResult0"):''
			let daterangeSelectResult1 = sessionStorage.getItem("daterangeSelectResult1")?sessionStorage.getItem("daterangeSelectResult1"):''
			this.daterangeSelectResult.push(daterangeSelectResult0) 
			this.daterangeSelectResult.push(daterangeSelectResult1) 
			this.enquery()
        },
        methods: {
			// 查询
			enquery() {
				this.loading = true
				sessionStorage.setItem("optionsvalue",this.optionsvalue);
				sessionStorage.setItem("daterangeSelectResult0",this.daterangeSelectResult[0])
				sessionStorage.setItem("daterangeSelectResult1",this.daterangeSelectResult[1])
				switch(this.optionsvalue){
					case 0:
						this.ismaterial = true;
						this.isclient = false;
						break;
					case 1:
						this.isclient = true;
						this.ismaterial = false;
						break;
					default:
						return;
				}
				this.$requestBase({
					url: `v1/ship/list/${this.optionlabel[this.optionsvalue]}`,
					method: 'get',
					params: this.pageInfo
				}).then(res => {
					this.responseData = this.formatResponse(res.data.list)
					this.loading = false
				}).catch(err => {
					this.loading = false
				})
				
			},
            // 获取XX分页列表
            getList(val) {
                this.pageInfo.page = val
                this.$requestBase({
                    url: 'v1/ship/list',
                    method: 'get',
                    params: this.pageInfo
                }).then(res => {
					this.pageInfo.size = res.data.total
                })
            },
            formatResponse(response) {
				response.forEach((item,index) => {
					item.productLength = (Number(item.productLength)/100).toFixed(2)
					item.productWeight = (Number(item.productWeight)/1000).toFixed(2)
					item.opration = '详情'
				})
				return response
            },

            gotoShipmentDetails(name, id) {
				sessionStorage.setItem("DetailPageInfo",JSON.stringify(this.pageInfo));
				this.$router.push({
					path: 'shipmentCountDetail',
					query: {
					    Name: name,
						Type: this.optionsvalue,
						Id: id
					}
				})
            },
            filterClient(value, row) {
                return row.client === value
            },
            filterMaterial(value, row) {
                return row.materialName === value
            },
            // 日期范围选择控件，内容改变事件
            daterangeSelectChange() {

                //    //开始时间 转 时间戳
                //    let m_date = new Date(this.daterangeSelectResult[0]);
                //    let m_time = Date.parse(m_date); //精确到秒,毫秒会用000替代
                //    this.pageInfo.startTime = m_time

                //    //结束时间 转 时间戳
                //    m_date = new Date(this.daterangeSelectResult[1]);
                //    m_time = Date.parse(m_date); //精确到秒,毫秒会用000替代
                //    this.pageInfo.endTime = m_time

                //    this.refreshPage()
            },
			Print() {
				if(this.isclient){
					this.initPrint('localListTableId_client')
				}else if(this.ismaterial){
					this.initPrint('localListTableId_material')
				}
			},
            // 在打印当前报表前，拼接title
            initPrint(id) {
                printJS({
                    // printable: 'pageDetail', type: 'html', targetStyles: ['*'], maxWidth: 1100, scanStyles: true
                    printable: id,
                    type: 'html',
                    targetStyles: ['*'],
                    maxWidth: 1100,
                    scanStyles: true,
                    header: '出货报表',
                    // style: `@page {size:auto;margin-top:100px; margin-left:15px; margin-right: 15px;}
                    //  thead th {
                    //    border-top: 2px solid #000;
                    //    border-right: 2px solid #000;
                    //    border-left: 2px solid #000;
                    //  }
                    //  tbody td {
                    //    border: 2px solid #000;
                    //  }
                    //  tbody {
                    //    text-align: center;
                    //  }
                    //  table {
                    //    border-collapse: collapse;
                    //  }`,					
                })
            },
            getSummaries(param) {
                const {
                    columns,
                    data
                } = param;
                const sums = [];
				let optionvalue = 0;
				if(this.isclient){
					optionvalue = 1;
				}else if(this.ismaterial){
					optionvalue = 0;
				}
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '汇总';
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        switch (index) {
                            case 3-optionvalue:
								sums[index] = sums[index].toFixed(2)
                                sums[index] += ' 千克';
                                break;
                            case 4-optionvalue:
								sums[index] = sums[index].toFixed(2)
                                sums[index] += ' 米';
                                break;
                            case 5-optionvalue:
                                sums[index] += ' 匹';
                                break;
							default:
								sums[index] = '';
								break;
                        }
                    } else {
                        sums[index] = '';
                    }
                });
                return sums;
            },
        }
    }
</script>

<style>
</style>
